import React, { useMemo } from 'react'

import S from './styled'
import { Input, Select, Status, ImageUpload, History, Tags } from  '../../../components'
import required from '../../../common/validators/required'
import { ingredientStatuses }  from '../../../common/ingredient'

const Ingredient = props => {

  const {
    foodKinds,
    regions,
    role,
  } = props

  const foodKindsSelect = useMemo(() => foodKinds.map(fk => ({ id: fk.id, name: fk.description })), [foodKinds])

  const { text, select, image, list } = props.model

  return (
    <S.Ingredient>
      <S.InredientInfo>
        <S.InredientDetails>
          <S.Inputs>
            <S.InputBlock>
              <Input {...{
                name: 'values.name',
                text,
                title: 'Unique Ingredient Name',
                validate: required,
                autoFocus: true,
              }}
              />
              <Select {...{
                name: 'values.foodKindId',
                select,
                title: 'Ingredient Food Category',
                values: foodKindsSelect,
                validate: required,
              }}
              />
            </S.InputBlock>
            <S.InputBlock>
              <S.ButtonsBlock>
                <History />
                <Status
                  title="Ingredient Status"
                  {...text({
                    name: 'values.ingredientStatus',
                  })}
                  statuses={ingredientStatuses}
                  role={role}
                />
              </S.ButtonsBlock>
              <Input {...{
                name: 'values.blsLink',
                text,
                title: 'BLS Link',
              }}
              />
            </S.InputBlock>
          </S.Inputs>
          <S.Tags>
            <Tags {...list({
              title: 'Local Availability',
              name: 'values.availableRegions',
              values: regions,
            })}
            />
          </S.Tags>
        </S.InredientDetails>
        <S.IngredientImage>
          <ImageUpload
            {...image({ name: 'values.image', title: 'Ingredient Main Image' })}
            width="360" height="360"
            mobileWidth="185" mobileHeight="185"
          />
        </S.IngredientImage>
      </S.InredientInfo>
    </S.Ingredient>
  )
}

export default Ingredient
